import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

export type IPasswordBoxProps = {
	name: string;
	value: string;
	onValueChanged: (value: string) => void;
	label?: string;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
	placeholder?: string;
	labelSmall?: boolean;
	isDisabled?: boolean;
	hasValid?: boolean;
};

export const PasswordBox = (props: IPasswordBoxProps) => {
	const [showPassword, setShowPassword] = useState(false);
	const {
		value,
		error,
		name,
		label,
		sizeClass,
		isDisabled,
		helpBlock,
		labelSmall,
		hasValid,
		placeholder,
		onValueChanged,
	} = props;
	const showError = !!error;

	return (
		<div className="space-y-2">
			{label && (
				<Label htmlFor={name} className={cn(labelSmall && "text-xs")}>
					{label} {hasValid && <span className='text-destructive'>(*)</span>}
				</Label>
			)}
			<div className="relative">
				<Input
					id={name}
					name={name}
					type={showPassword ? 'text' : 'password'}
					value={value || ''}
					disabled={isDisabled}
					placeholder={placeholder}
					onChange={(e) => onValueChanged(e.target.value)}
					className={cn(showError && "border-destructive", "pr-10")}
				/>
				<Button
					type="button"
					variant="ghost"
					size="sm"
					className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
					onClick={() => setShowPassword((prev) => !prev)}
					tabIndex={-1}
				>
					{showPassword ? (
						<EyeOff className="h-4 w-4 text-muted-foreground" />
					) : (
						<Eye className="h-4 w-4 text-muted-foreground" />
					)}
				</Button>
			</div>
			{showError && <p className="text-sm font-medium text-destructive">{error}</p>}
			{helpBlock && <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{ __html: helpBlock }} />}
		</div>
	);
};
